import styled from "styled-components";


export const Container = styled.div`
position: relative;
`;
export const PopularWeaponsContainer = styled.div`
position: relative;
padding: 50px 0px;
`;

export const TextWrapper = styled.div`
@media(max-width: 640px){
  display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: start;
}
`;

export const Text = styled.text`
font-family: SweraDemo;
color: #e3e3e3;
font-size: 24px;
font-weight: 900;
line-height: 32px;
display: flex;
align-items: center;
/* color: #dddddd; */
text-transform: uppercase;
padding-left: 10px;
@media(max-width:768px){
  font-size:24px;
}
`;

export const ViewAllWrapper = styled.div`
@media(max-width:650px){
  display: flex;
  justify-content:flex-end;
  align-items:start;
  text-align:center;
width: 50%;
}
`;

export const ViewButton = styled.button`
  background: #203736;
  border-radius: 30px;
  font-size: 16px;
  color: #88FEFE;
  padding: 12px 24px;
  outline: none;
  border: none;
  cursor: pointer;
  color: #88FEFE;
`;

export const HeadingTextcontainer = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
text-align: center;
margin: 50px 0 20px 0;
@media(max-width:650px){
  margin-top: 40px !important;
}
`;

export const NftGridContainer = styled.div`
  
`;

export const NftGridWrapper = styled.div`
  backdrop-filter: blur(17.915px);
  border-radius: 20px;
  background-color: #151a1c;
  width: 100%;
  display: inline-block;
  position: relative;
`;

export const NftNewArivalWrapper = styled.div`
    display: flex;
    -webkit-box-pack: center;
    width: 90%;
    cursor: pointer;
    border-radius: 20px;
    background-color: #262a2d;
    margin: 5%;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;
    padding: 15px 0;
`;
// background-color: #e3c5ff;
    // color: #8a2be2;
export const NftCategory = styled.div`
  font-size: 9px;
  font-weight: 800;
  color: #490d81;
  text-transform: uppercase;
  /* background-color: #d3b1f3; */
  background-color: ${props =>props.common ? '#dddddd' : props.uncommon ? '#a5e3b8' : 'initial'}; 
  padding: 7px 12px;
  border-radius: 50px;
  position: absolute;
  bottom: 10px;
     /* right: -5px; */
    right: 5px;

  /* opacity: 0.7; */
  ${(p)=>p.uncommon && `
    background-color: #22363e;
    color: #74bccb;
  `};
  ${(p)=>p.common && `
    background-color: #392e4a;
    color: #a98bc5;
  `};
`;
export const NftNewArival = styled.img`
    width: 200px;
    height: 152px;
    aspect-ratio: auto 200 / 152;
    transition: 0.5s;
    cursor: pointer;
    &:hover{
    transform: scale(1.3);
  }
`;

export const NftNameWrapper = styled.div`
display: flex;
flex-direction: column;
justify-content: space-between;
text-align: start;
align-items: flex-start ;
width: 100%;
padding: 0 15px;
`;

export const NftNameText = styled.text`
font-size: 18px;
    font-weight: 600;
  margin: 4px 0;
font-style: normal;
padding: 3px 0px 10px;
line-height: 22px;
text-transform: capitalize;
color: #fff;
@media(max-width:768px){
font-size:16px;
  }
@media(max-width:1440px){
font-size:18px;
  }
`;
export const NftNameTextWrapper=styled.div`
display: flex;
justify-content: space-between;
align-items: center;
width: 100%;
`
export const NftCountText = styled.text`
font-size: 14px;
font-weight: 400;
padding: 3px 0px 10px;
font-style: normal;
color: #FB9829;
`
export const NftNameHash = styled.text`
font-size: 22px;
font-weight: 600;
font-style: normal;
color: #fff;
padding: 10px 0;
@media(max-width:768px){
font-size:16px;
  }
`;

export const PriceButtonContainer = styled.div`
display: flex;
/* margin: 10px 20px 20px 20px; */
margin: 0px 15px 20px 15px;
justify-content: space-between;
align-items: center;
text-align: center;

`;

export const PriceWrapper = styled.div`
width:45%;
line-height: 22px;
display: flex;
color:#8A8AA0;
flex-direction:column;
justify-content:center;
align-items: flex-start;

${(p)=>p.hashValue && `
align-items:end;
`}
@media(max-width:1260px){
 width: 50%;
}
@media(max-width:1899px){
 width: 50%;
}
`;



export const PriceText = styled.text`

${(p)=>p.Heading && `
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #8A8AA0;
    text-align: start;
    margin: 0;
`}
${(p)=>p.PriceTextValue && `
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    color: #25a8c5;
    margin: 5px 0 0px 0;
    text-align: start;
    text-transform: capitalize;
`}
${(p)=>p.PriceHashValue && `
    font-size: 18px;
    font-weight: 600;
    font-style: normal;
    color: #fff;
`}
`;
export const Pricevalue = styled.div`
 font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    color: #25a8c5;
    margin: 5px 0 0px 0;
    text-align: start;
text-transform: capitalize;

`;

export const ButtonWrapper = styled.div`
/* width: 45%;
  @media(max-width:1260px){
  width: 50%;
  }
  @media(max-width:1899px){
 width: 50%;
} */
`;
export const Button = styled.button`
  background: #fff;
  border-radius: 30px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  padding: 10px 20px;
  color: #000;
  border: none;
  outline: none;
  cursor: pointer;
  transition: 0.5s;
  &:hover{
    background: #1c3741;
    color: #208da5;
  }
@media(max-width:1260px){
  font-size:14px;
 padding: 8px 15px;
}
@media(max-width:540px){
  font-size:20px;
 padding: 20px 35px;
}
@media(max-width:420px){
  font-size:18px;
 padding: 10px 20px;
}
`;